import { useMemo } from "react";
import { Product } from "../types";
import { useVoucherContext } from "../contexts/VoucherContext";
import { vouchersMatchProduct } from "../utils/voucherMatching";

/**
 * Lightweight hook for checking if a product has free delivery via vouchers
 * Uses shared VoucherContext and memoized matching cache
 * @param product - The product to check
 * @returns boolean indicating if product has free delivery from vouchers
 */
export function useVoucherBadge(product: Product | null | undefined): boolean {
  const { activeFreeDeliveryVouchers } = useVoucherContext();

  const hasVoucherFreeShipping = useMemo(() => {
    // Early return if product already has free shipping (no need to check vouchers)
    if (product?.hasFreeShipping) {
      return false;
    }
    
    if (!product || !activeFreeDeliveryVouchers || activeFreeDeliveryVouchers.length === 0) {
      return false;
    }

    return vouchersMatchProduct(activeFreeDeliveryVouchers, product);
  }, [product, activeFreeDeliveryVouchers]);

  return hasVoucherFreeShipping;
}

